module.exports = __webpack_public_path__ + "img/bg-history.1e2743ae.png";